var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page", attrs: { id: "Download" } },
    [
      _c("appModal", {
        ref: "appModalRef",
        attrs: { countries: _vm.DBCountries }
      }),
      _c("appHeader", {
        attrs: { bgColor: "blue", page: "download" },
        on: { headerMenuClicked: _vm.menuClicked }
      }),
      _c(
        "div",
        {
          class: _vm.citationModalDisplayed ? "displayed" : "",
          attrs: { id: "CiteModalWrapper" }
        },
        [
          _c("div", {
            attrs: { id: "CiteModalBg" },
            on: {
              click: function($event) {
                return _vm.closeCitationModal()
              }
            }
          }),
          _c("div", { attrs: { id: "CiteModal" } }, [
            _c("div", {
              staticClass: "modal_closebt",
              on: {
                click: function($event) {
                  return _vm.closeCitationModal()
                }
              }
            }),
            _c("div", { staticClass: "modal_title" }, [
              _vm._v("How to cite ?")
            ]),
            _c("div", {
              staticClass: "modal_text",
              domProps: { innerHTML: _vm._s(_vm.citationModalText) }
            }),
            _c("div", { staticClass: "modal_buttons" }, [
              _c(
                "div",
                {
                  staticClass: "modal_bt",
                  class: _vm.copiedType == "text" ? "copied" : "",
                  on: {
                    click: function($event) {
                      return _vm.updateModalText("text")
                    }
                  }
                },
                [
                  _c("span", { staticClass: "copied_text" }, [
                    _vm._v("Copied")
                  ]),
                  _c("span", { staticClass: "bt_text" }, [_vm._v("Copy text")])
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "modal_bt",
                  class: _vm.copiedType == "apa" ? "copied" : "",
                  on: {
                    click: function($event) {
                      return _vm.updateModalText("apa")
                    }
                  }
                },
                [
                  _c("span", { staticClass: "copied_text" }, [
                    _vm._v("Copied")
                  ]),
                  _c("span", { staticClass: "bt_text" }, [_vm._v("Copy APA")])
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "modal_bt",
                  class: _vm.copiedType == "bip" ? "copied" : "",
                  on: {
                    click: function($event) {
                      return _vm.updateModalText("bip")
                    }
                  }
                },
                [
                  _c("span", { staticClass: "copied_text" }, [
                    _vm._v("Copied")
                  ]),
                  _c("span", { staticClass: "bt_text" }, [
                    _vm._v("Copy BipTex")
                  ])
                ]
              )
            ])
          ])
        ]
      ),
      _c("div", { staticClass: "main" }, [
        _c(
          "div",
          { staticClass: "main_inner" },
          [
            _vm._m(0),
            _vm._l(_vm.DBDownloads, function(downloadObj, briefIndex) {
              return _c(
                "section",
                { staticClass: "main_section section_download" },
                [
                  _c("div", { staticClass: "section_content" }, [
                    _c("div", { staticClass: "content_title" }, [
                      _vm._v(_vm._s(downloadObj.title))
                    ]),
                    _c("div", { staticClass: "content_date" }, [
                      _vm._v("Last update " + _vm._s(downloadObj.date))
                    ]),
                    _c("div", { staticClass: "content_details" }, [
                      _c("div", { staticClass: "content_image" }, [
                        _c("img", {
                          attrs: {
                            src: "/images/thumbnails/" + downloadObj.thumbnail
                          }
                        })
                      ]),
                      _c("div", { staticClass: "content_desc" }, [
                        _c("div", { staticClass: "desc_title" }, [
                          _vm._v("About this database:")
                        ]),
                        _c("div", {
                          domProps: { innerHTML: _vm._s(downloadObj.text) }
                        }),
                        _c("div", { staticClass: "content_actionbar" }, [
                          downloadObj.datasetID != null &&
                          _vm.DBDownloadsSheetObj[downloadObj.datasetID] !=
                            undefined
                            ? _c(
                                "a",
                                {
                                  staticClass: "actionbar_bt",
                                  attrs: {
                                    href:
                                      _vm.DBDownloadsSheetObj[
                                        downloadObj.datasetID
                                      ].data_link
                                  }
                                },
                                [_vm._v("Download data (.csv)")]
                              )
                            : _vm._e(),
                          downloadObj.datasetID != null &&
                          _vm.DBDownloadsSheetObj[downloadObj.datasetID] !=
                            undefined
                            ? _c(
                                "a",
                                {
                                  staticClass: "actionbar_bt",
                                  attrs: {
                                    href:
                                      _vm.DBDownloadsSheetObj[
                                        downloadObj.datasetID
                                      ].methodo_link,
                                    "data-bt": "methodo"
                                  }
                                },
                                [_vm._v("Download methodology")]
                              )
                            : _vm._e(),
                          _c(
                            "a",
                            {
                              staticClass: "actionbar_bt",
                              attrs: { "data-bt": "cite" },
                              on: {
                                click: function($event) {
                                  return _vm.displayCitationModal(downloadObj)
                                }
                              }
                            },
                            [_vm._v("Cite")]
                          )
                        ])
                      ])
                    ])
                  ])
                ]
              )
            })
          ],
          2
        )
      ]),
      _c("appFooter"),
      _c("cookiesConsent")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "main_section" }, [
      _c("div", { staticClass: "section_content" }, [
        _c("h2", { staticClass: "text_subtitle" }, [_vm._v("-")]),
        _c("h1", { staticClass: "title_page text_title2" }, [
          _vm._v(
            "\n                        Download data & methodology\n                    "
          )
        ]),
        _c(
          "p",
          { staticClass: "text_p", staticStyle: { "margin-top": "24px" } },
          [
            _vm._v(
              "\n                        Here you will find complete annotated versions of the four datasets that make up the Atlas as well as detailed methodology notes that describe how each series was constructed.\n                    "
            )
          ]
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-270e26ae", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-270e26ae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/download-data/index.vue
// module id = i1G4
// module chunks = 6